export default __webpack_public_path__ + "static/media/Holicef-500-mg-IV-eng.a85408d8.jpg";